"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var row_type_1 = require("../model/row-type");
var row_view_model_1 = require("../../model/row-view.model");
var rows_root_view_model_1 = require("../../model/rows-root-view.model");
var rows_change_event_type_1 = require("../../model/event/rows-change-event-type");
var table_row_type_1 = require("../../model/table-row-type");
var rows_change_event_1 = require("../../model/event/rows-change-event");
var row_option_1 = require("../../model/row-option");
var RowViewDragAndDropManager = /** @class */ (function () {
    function RowViewDragAndDropManager(fetchRowsRootViewModel, viewEventService) {
        /**
         * Is current position is valid drop position
         */
        this.allowDrop = false;
        this.fetchRowsRootViewModel = fetchRowsRootViewModel;
        this.viewEventService = viewEventService;
    }
    RowViewDragAndDropManager.prototype.draggable = function (rowView) {
        if (rowView instanceof rows_root_view_model_1.RowsRootView) {
            return false;
        }
        return rowView.rowType !== row_type_1.RowType.NEW;
    };
    RowViewDragAndDropManager.prototype.dragstart = function (event, rowView) {
        if (rowView instanceof row_view_model_1.RowView && rowView.rowType !== row_type_1.RowType.NEW) {
            this.dragRowView = rowView;
            rowView.isDragging = true;
        }
    };
    RowViewDragAndDropManager.prototype.dragenter = function (event, rowView) {
        // reset flag indicate is drop allowed
        this.allowDrop = false;
        // always allow to drop element to root.
        if (rowView instanceof rows_root_view_model_1.RowsRootView) {
            this.allowDrop = true;
            this.getRowsRoot().dragEntered = true;
            this.getRowsRoot().removeByCondition(function (row) { return row.rowType === row_type_1.RowType.NEW; });
            this.getRowsRoot().setIndexes(); // reset indexes
            var options = this.getRowsRoot().getCollapsedExpandedOptions()
                .setRowsCount(this.getRowsRoot().rowsCount)
                .setInfo(this.getRowsRoot().getRowsInfo())
                .add(this.getRowsRoot().rowsCount, new row_option_1.RowOption(table_row_type_1.TableRowType.HIGHLIGHTED));
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_DEACTIVATED, options));
            return;
        }
        // skip temporary added new elements.
        if (rowView.rowType === row_type_1.RowType.NEW) {
            this.getRowsRoot().removeByCondition(function (row) { return row.rowType === row_type_1.RowType.NEW; });
            // reset indexes
            this.getRowsRoot().setIndexes();
            var options = this.getRowsRoot().getCollapsedExpandedOptions().setRowsCount(this.getRowsRoot().rowsCount).setInfo(this.getRowsRoot().getRowsInfo());
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_DEACTIVATED, options));
            return;
        }
        // skip when drag row not exist or drag row is parent of current row
        if (!this.dragRowView || this.hasDraggingParent(rowView)) {
            this.resetState();
            return;
        }
        // do not allow to drag row category node in branch where that category path already exist.
        var dropBranchPathIds = this.parentRowElementPathIds(rowView);
        var dragBranchPathIds = this.childRowElementPathIds(this.dragRowView);
        var alreadyExists = dragBranchPathIds.some(function (pathId) { return dropBranchPathIds.includes(pathId); });
        if (alreadyExists) {
            this.resetState();
            return;
        }
        if (rowView !== this.dragRowView) {
            // set flag to indicate that drop allowed
            this.allowDrop = true;
            this.getRowsRoot().removeByCondition(function (row) { return row.rowType === row_type_1.RowType.NEW; });
            var newRow = new row_view_model_1.RowView();
            newRow.rowType = row_type_1.RowType.NEW;
            rowView.showNew = true;
            // remove expanded class from rowView's branch
            var item = rowView;
            while (item != null) {
                item.collapsed = undefined;
                item = item.parent;
            }
            rowView.add(newRow);
            this.getRowsRoot().cleanCreatedRowIndexes();
            // clean removed element
            this.getRowsRoot().cleanRemovedElements();
            // reset indexes
            this.getRowsRoot().setIndexes(newRow);
            // send event to activate current row in table view
            var prevIndex = this.getRowsRoot().findPreviousVisibleElementIndex(newRow.index);
            var nextIndex = this.getRowsRoot().findNextVisibleElementIndex(newRow.index);
            var options = this.getRowsRoot().getCollapsedExpandedOptions()
                .add(newRow.index, new row_option_1.RowOption(table_row_type_1.TableRowType.NEW, true))
                .add(prevIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.BEFORE_NEW, true))
                .add(nextIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.AFTER_NEW, true))
                .setRowsCount(this.getRowsRoot().rowsCount).setInfo(this.getRowsRoot().getRowsInfo());
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_ACTIVATED, options));
        }
        else if (rowView === this.dragRowView) {
            this.getRowsRoot().removeByCondition(function (row) { return row.rowType === row_type_1.RowType.NEW; });
            // reset indexes
            this.getRowsRoot().setIndexes();
            var options = this.getRowsRoot().getCollapsedExpandedOptions().setRowsCount(this.getRowsRoot().rowsCount).setInfo(this.getRowsRoot().getRowsInfo());
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_DEACTIVATED, options));
        }
    };
    RowViewDragAndDropManager.prototype.dragover = function (event, rowView) {
        if (this.allowDrop) {
            event.preventDefault();
        }
    };
    RowViewDragAndDropManager.prototype.drop = function (event, rowView) {
        var dropNode;
        if (rowView instanceof rows_root_view_model_1.RowsRootView) {
            dropNode = this.getRowsRoot();
        }
        else if (rowView instanceof row_view_model_1.RowView && rowView.rowType !== row_type_1.RowType.NEW && rowView !== this.dragRowView) {
            dropNode = rowView;
        }
        if (dropNode) {
            // delete drag element from previous position
            if (this.dragRowView.parent) {
                this.dragRowView.parent.remove(this.dragRowView);
            }
            else {
                this.getRowsRoot().remove(this.dragRowView);
            }
            // remove new element
            this.getRowsRoot().removeByCondition(function (row) { return row.rowType === row_type_1.RowType.NEW; });
            // add drag element to new position
            dropNode.add(this.dragRowView);
            // reset indexes
            this.getRowsRoot().setIndexes();
            var index = this.dragRowView.index;
            this.getRowsRoot().setCreatedRowIndexes(index);
            this.getRowsRoot().cleanNewRowIndexes();
            // send event to create row in table view
            var prevIndex = this.getRowsRoot().findPreviousVisibleElementIndex(index);
            var nextIndex = this.getRowsRoot().findNextVisibleElementIndex(index);
            var options = this.getRowsRoot().getCollapsedExpandedOptions()
                .add(index, new row_option_1.RowOption(table_row_type_1.TableRowType.CREATED, true))
                .add(prevIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.BEFORE_CREATED, true))
                .add(nextIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.AFTER_CREATED, true))
                .setRowsCount(this.getRowsRoot().rowsCount).setInfo(this.getRowsRoot().getRowsInfo());
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_CREATED, options));
        }
        // reset isDragging flag on row
        this.dragRowView.isDragging = false;
        this.dragRowView = undefined;
        // reset flag indicate is drop allowed
        this.allowDrop = false;
        this.resetState();
    };
    RowViewDragAndDropManager.prototype.dragend = function (event, rowView) {
        // reset isDragging flag on row
        if (this.dragRowView) {
            this.dragRowView.isDragging = false;
            this.dragRowView = undefined;
        }
        // reset flag indicate is drop allowed
        this.allowDrop = false;
        this.resetState();
    };
    RowViewDragAndDropManager.prototype.dragleave = function (event, rowView) {
        if (rowView instanceof rows_root_view_model_1.RowsRootView) {
            this.getRowsRoot().dragEntered = false;
            var options = this.getRowsRoot()
                .getCollapsedExpandedOptions()
                .setRowsCount(this.getRowsRoot().rowsCount)
                .setInfo(this.getRowsRoot().getRowsInfo());
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_UNHIGHLIGHTED, options));
        }
    };
    RowViewDragAndDropManager.prototype.destroy = function () {
    };
    RowViewDragAndDropManager.prototype.getRowsRoot = function () {
        // invoke fetchRowsRootViewModel Lambda function to fetch rows root view model from component.
        return this.fetchRowsRootViewModel();
    };
    RowViewDragAndDropManager.prototype.resetState = function () {
        // remove new element
        this.getRowsRoot().removeByCondition(function (row) { return row.rowType === row_type_1.RowType.NEW; });
        // reset indexes
        this.getRowsRoot().setIndexes();
        // reset showNew and prepareNew flags
        this.getRowsRoot().cleanShowNewFlags();
        this.getRowsRoot().cleanPrepareNewFlags();
        // send event to reset rows in table view
        var options = this.getRowsRoot().getCollapsedExpandedOptions().setRowsCount(this.getRowsRoot().rowsCount).setInfo(this.getRowsRoot().getRowsInfo());
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_DEACTIVATED, options));
    };
    RowViewDragAndDropManager.prototype.hasDraggingParent = function (rowView) {
        return rowView.parent && (rowView.parent.isDragging || this.hasDraggingParent(rowView.parent));
    };
    RowViewDragAndDropManager.prototype.parentRowElementPathIds = function (rowView) {
        var pathIds = [];
        var node = rowView;
        while (node) {
            pathIds.push(node.element.categoryElementDto.categoryPathHolderId);
            node = node.parent;
        }
        return pathIds;
    };
    RowViewDragAndDropManager.prototype.childRowElementPathIds = function (rowView) {
        var pathIds = [];
        if (rowView.rowType === row_type_1.RowType.SPECIFIED) {
            pathIds.push(rowView.element.categoryElementDto.categoryPathHolderId);
            for (var _i = 0, _a = rowView.children; _i < _a.length; _i++) {
                var child = _a[_i];
                pathIds.push.apply(pathIds, this.childRowElementPathIds(child));
            }
        }
        return pathIds;
    };
    return RowViewDragAndDropManager;
}());
exports.RowViewDragAndDropManager = RowViewDragAndDropManager;
//# sourceMappingURL=rowview-drag-and-drop-manager.js.map